import { MetricChartDialog as CoreMetricChartDialog } from "@/core/components/exposed-values/MetricChartDialog";

interface MetricChartDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mappingId: string;
  displayName: string;
  unit: string | null;
  currentValue?: number | string | null;
}

export const MetricChartDialog = (props: MetricChartDialogProps) => (
  <CoreMetricChartDialog translationPrefix="mod_energy.energy_management.chart" {...props} />
);
